import { isEqual } from 'lodash';

const difference = (opts, subjects, nextDiff = {}) => {
  const length = subjects.length;
  const ref = subjects[0];
  const diff = nextDiff;
  const equal = (opts && opts.equal) || isEqual;
  let c;
  let keys;
  let keysLength;
  let key;
  let u;

  for (let i = 1; i < length; i++) {
    c = subjects[i];
    keys = Object.keys(c);
    keysLength = keys.length;

    for (u = 0; u < keysLength; u++) {
      key = keys[u];

      if (!equal(c[key], ref[key])) diff[key] = c[key];
    }
  }

  return diff;
};

const strict = (...subject) => {
  return difference(null, subject);
};

const custom = (opts, ...subject) => {
  return difference(opts, subject);
};

strict.custom = custom;

export default strict;
